import { isFunction, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";
import { OneTapDelegate } from "./OneTapDelegate.js";

export interface ProviderHasOneTapDelegate {


    setOneTapDelegate(newDelegate: OneTapDelegate): void;

}

export function isProviderHasOneTapDelegate(obj: any): obj is ProviderHasOneTapDelegate {

    return isObject(obj) && isFunction(obj['setOneTapDelegate']);

}